import { AxiosResponse } from "axios";
import { Requests } from "../../config/api";
import { getRequest } from "../commonActions/get";
import { postRequest } from "../commonActions/post";

export const GetAvailability = async (
  page: number,
  limit: number,
  available: boolean,
  setLoading?: (loading: boolean) => void
): Promise<any> => {
  try {
    // Set loading state to true if setLoading is provided
    setLoading && setLoading(true);

    // Make the API request
    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getAvailability}?page=${page}&limit=${limit}&available=${available}`,
    });

    // Extract relevant data from the response
    const availability = response?.data?.packages;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    // Set loading state to false if setLoading is provided
    setLoading && setLoading(false);

    // Return the extracted data
    return {
      status: status,
      availability: availability,
      message: message,
      errors: errors,
    };
  } catch (error) {
    // Set loading state to false if setLoading is provided
    setLoading && setLoading(false);

    // Log the error and rethrow it
    console.error("Error in GetAvailability:", error);
    throw error;
  }
};

export const AddAvailability = async (
  payload: any,
  setLoading?: (loading: boolean) => void
): Promise<any> => {
  try {
    // Set loading state to true if setLoading is provided
    setLoading && setLoading(true);

    // Make the API request
    const response: AxiosResponse = await postRequest({
      route: Requests.post.addAvailability,
      payload: payload,
    });

    // Extract relevant data from the response
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    // Set loading state to false if setLoading is provided
    setLoading && setLoading(false);

    // Return the extracted data
    return {
      status: status,
      message: message,
      errors: errors,
    };
  } catch (error) {
    // Set loading state to false if setLoading is provided
    setLoading && setLoading(false);

    // Log the error and rethrow it
    console.error("Error in AddAvailability:", error);
    throw error;
  }
};
